<template>
    <div>

        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
<!--        <h2 class="subtitle has-text-weight-bold">Jobs Tray   <span  class="has-text-grey">{{getNameAndSurname}}</span>  Total {{ myJobsTray.length }} Records. </h2>-->


        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <b-button type="is-success"   icon-left="refresh" outlined  @click="reloadMyJobsTray">Refresh My Jobs Tray</b-button>
                </div>

            </div>
            <div class="level-right">

            </div>
        </nav>



        <b-table
                :data="isEmpty ? [] : myJobsTrayList "
                bordered
                striped
                narrowed
                hoverable
                :loading="isLoading"
                focusable
                mobile-cards
        >
            <!--            checkable-->
            <!--            :selected.sync="rowsSelected"-->





                <b-table-column  label="Lab No." centered v-slot="props">
                    <b-button type="is-info" @click="editLab(props.row.idlab,props.row.idopd,props.row.kind)"  >{{ props.row.idlab }}</b-button>
                </b-table-column>
                <b-table-column  label="Kind" centered v-slot="props">
                    {{ props.row.kind }}
                </b-table-column>
                <b-table-column  label="OPD No." centered v-slot="props">
                    {{ props.row.idopd }}
                </b-table-column>
                <b-table-column  label="Pet Name" centered v-slot="props">
                    {{ props.row.opdname }}
                </b-table-column>
                <b-table-column  label="Owner" centered v-slot="props">
                    {{ props.row.ownername }}
                </b-table-column>
                <b-table-column  label="Species/Breed" centered v-slot="props">
                    {{ props.row.species }}/{{ props.row.breed }}
                </b-table-column>
                <b-table-column  label="Gender" centered v-slot="props">
                    {{props.row.gender === 'M' ? 'male' : 'female'}}
                    <span >
                     <!-- <b-icon pack="fas" type="is-text"
                       :icon="props.row.gender === 'M' ? 'mars' : 'venus'">
                     </b-icon> -->
                     <b-icon 
                       :icon="props.row.gender === 'M' ? 'gender-male' : 'gender-female'">
                     </b-icon>
                    </span>
                </b-table-column>
                <b-table-column  label="Age" centered v-slot="props">
                    {{ props.row.age }}
                </b-table-column>
                <b-table-column  label="Status" centered v-slot="props">
                    {{ props.row.status }}
                </b-table-column>
                <b-table-column  label="Assigned" centered v-slot="props">
                    {{ props.row.date_assigned }}  {{ props.row.time_asigned }}
                </b-table-column>
                <b-table-column  label="Assigned By" centered v-slot="props">
                    {{ props.row.user_assigned }}
                </b-table-column>





            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                    icon="emoticon-sad"
                                    size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
            <template slot="footer"  >

            </template>


        </b-table>

        <EditDocLABTxtKind ref="EditDocLABTxtKind"
                           :IDLABSelected="IDLABSelected"
                           @close="closeEditDocLAB"
        />

        <EditDocLabBiopsy  ref="EditDocLabBiopsy"
                           :IDLABSelected="IDLABSelected"
                           @close="closeEditDocLAB"
        />

        <EditDocLabPCR
                :isComponentModalActive="isPCREditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabPCR"
         />

        <EditDocLabBact
                :isComponentModalActive="isBACTEditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabBACT"
          />


        <EditDocLabPARA
                :isComponentModalActive="isPARAEditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabPARA"
          />


        <EditDocLabOrga
                :isComponentModalActive="isORGAEditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabORGA"
        />


         <EditDocLabNecrop
                ref="EditDocLabNecropsy"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLAB"


        />



    </div>
</template>

<script>
    /* eslint-disable no-console */
    import {mapState , mapActions} from 'vuex'
    import EditDocLABTxtKind from "../LABNonAutomate/EditDocLABTxtKind";
    import EditDocLabBiopsy from "../LABNonAutomate/EditDocLabBiopsy";
    import axios from 'axios'
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    import reloadMyJobsTray from "../../mixins/methods/reloadMyJobsTray";
    import EditDocLabPCR from "../LABNonAutomate/EditDocLabPCR";
    import EditDocLabBact from "../LABNonAutomate/EditDocLabBact";
    import EditDocLabOrga from "../LABNonAutomate/EditDocLabOrga";
    import EditDocLabNecrop from "../LABNonAutomate/EditDocLabNecrop";
    import EditDocLabPARA from "../LABNonAutomate/EditDocLabPARA";


    
    export default {
        name: "MyJobsTray",
        components:{
            EditDocLABTxtKind,
            EditDocLabBiopsy,
            EditDocLabPCR ,
            EditDocLabBact,
            EditDocLabOrga,
            EditDocLabNecrop,
            EditDocLabPARA,
        },
        props:{
            status : Number
        },
        mixins:[reloadMyJobsTray],
        computed:{
            ...mapState({
                myJobsTrayAssigned :  state => state.myjobstray.myJobsTrayAssigned ,
                myJobsTrayPrepared :  state => state.myjobstray.myJobsTrayPrepared ,
                myJobsTrayDraft :  state => state.myjobstray.myJobsTrayDraft ,
                myJobsTrayIncomplete:  state => state.myjobstray.myJobsTrayIncomplete ,
                IDLABSelected : state => state.lab_target.lab_selected,
                user_id : state => state.master_data.user_id ,
                clientIP : state => state.master_data.clientIP ,
            }),
            getNameAndSurname(){
                return localStorage.getItem('user_name_surname')
            },
            myJobsTrayList: function () {

               var tmp = []
                if (this.status === 2){
                      tmp = this.myJobsTrayAssigned
                }
                else if (this.status === 3){
                      tmp =  this.myJobsTrayPrepared
                }
                else if (this.status === 4){
                      tmp =  this.myJobsTrayDraft
                }
                else if (this.status === 5){
                    tmp =  this.myJobsTrayIncomplete
                }

                return tmp
            }
        },
        methods:{
            ...mapActions({
                setupIDOPDTarget : 'opd_target/setupIDOPDTarget',
                setupIDLABTarget : 'lab_target/setupIDLABTarget',
                fetchMyJobsTray:   'myjobstray/fetchMyJobsTray' ,

                fetchListOfLab_OPDTargetV2 :'listoflab_opdtarget/fetchListOfLab_OPDTargetV2',

            }),

            closeEditDocLAB(){
                this.$buefy.toast.open(` close edit lab & refresh job tray`)
                this.reloadMyJobsTray()
            },
            editLab(idlab,idopd,kind){
                // console.log(idlab + idopd + kind)
                // this.$router.push('/temptest')
                 if(!this.user_id){
                     this.$router.push('/login')
                         .catch(()=>{});
                     return
                 }



                this.$buefy.toast.open( ` Get Information for Lab  ${kind}  ${idlab}  ` )
                // assigned idlab into state
                this.setupIDLABTarget({"idlab": idlab, "kind": kind})


                const vm = this
                const datTo = {
                    "idopd": idopd,
                    "user": this.user_id,
                    "ip": this.clientIP
                }
                // console.log(JSON.stringify(datTo))
                axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn`, datTo, getConfigAxios())
                    .then(res => {
                            // assigned idopd into state
                            vm.OPDSelected = {
                                "idopd": res.data.idopd,
                                "idlab": "",
                                "opdname": res.data.name,
                                "type": res.data.species + '(' + res.data.breed + ')',
                                "owner_name": res.data.owner_name,
                                "status": "",
                                "gender": res.data.sex,
                                "age": res.data.age,
                                "kind": "",
                                "automate": "",
                                "datereq": "",
                                "timereq": "",
                                "reqby": "",
                                "dateaccept": "",
                                "timeaccept": "",
                                "acceptby": "",
                                "datecancle": "",
                                "timecancle": "",
                                "cancleby": "",
                                "datereject": "",
                                "timereject": "",
                                "rejectby": "",
                                "dateresult": "",
                                "timeresult": "",
                                "resultby": ""
                            }

                            vm.setupIDOPDTarget(vm.OPDSelected)

                        }
                    )
                    .catch(err => {
                        // console.log(err)
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })
                    .finally(() => {

                    })

                //
                vm.fetchListOfLab_OPDTargetV2(idopd)

                // everthing all except incomplete status
                // if incomplete status (id === 5 ) set swap tab

                if(this.status < 5 ) {


                    // console.log('kind--->  ',kind)

                    if (kind.toUpperCase() === 'BIOPSY') {
                        this.$refs.EditDocLabBiopsy.loadData()
                        this.$refs.EditDocLabBiopsy.getMyTemplateLocal()
                        this.$refs.EditDocLabBiopsy.isComponentModalActive = true

                    }

                    if (kind.toUpperCase() === 'CYTOLOGY') {
                        this.$refs.EditDocLABTxtKind.loadData()
                        this.$refs.EditDocLABTxtKind.getMyTemplateLocal()
                        this.$refs.EditDocLABTxtKind.isComponentModalActive = true
                    }

                    if (kind.toUpperCase() === 'PCR') {
                        this.isPCREditorShowing = true
                    }

                    if (kind.toUpperCase() === 'BACTERIAL') {
                        this.isBACTEditorShowing = true
                    }



                    if (kind.toUpperCase() === 'PARASITE') {
                        this.isPARAEditorShowing = true
                    }
 
                    // Parasite


                    if (kind.toUpperCase() === 'ORGANISM') {
                        this.isORGAEditorShowing = true
                    }

                    if (kind.toUpperCase() === 'NECROPSY') {
                        // this.isNECROPEditorShowing = true]
                        //  console.log("Necropsy")
                         this.$refs.EditDocLabNecropsy.loadData()
                         this.$refs.EditDocLabNecropsy.getMyTemplateLocal()
                         this.$refs.EditDocLabNecropsy.isComponentModalActive = true
                    }


                    } else {

                            const tmpDat = {"idlab":idlab,"idopd":idopd,"kind":kind.toUpperCase()}
                            this.$emit('MyJobTrayLabStatus5WantToSwapTabToView',tmpDat)

                        }

            },
            closeEditDocLabPCR(){
                this.isPCREditorShowing = false
            },

            closeEditDocLabBACT(){
                this.isBACTEditorShowing = false
            },

            closeEditDocLabPARA(){
                this.isPARAEditorShowing = false
            },


            closeEditDocLabORGA(){
                this.isORGAEditorShowing = false
            },

            closeEditDocLabNecrop(){
                this.isNECROPEditorShowing = false
            }

        },
        data(){
            return {
                isLoading : false,
                isEmpty: false,
                OPDSelected:{},
                isFullScreenLoading : false,


                //  switch modal
                isPCREditorShowing : false,
                isBACTEditorShowing : false,
                isPARAEditorShowing : false,
                isORGAEditorShowing : false,
                isNECROPEditorShowing: false,
            }
        }
    }
</script>

<style scoped>

</style>